import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgNotFoundDirective } from './img-not-found.directive';
import { AutoFocus } from './autofocus.directive';
import { RolesDirective } from './role.directive';

@NgModule({
	declarations: [ImgNotFoundDirective, AutoFocus, RolesDirective],
	imports: [CommonModule],
	exports: [ImgNotFoundDirective, AutoFocus, RolesDirective],
})
export class DirectivesModule {}
